import { SET_SEARCH_QUERY } from "./reducer";

export function setSearchQuery(query: string) {
  return {
    type: SET_SEARCH_QUERY,

    payload: query,
  };
}
